export const create = {
  createSuccessfully: 'Create new detergent history successfully!',
}
